export const USERS_TABLE_HEAD = [
  { id: 'checkbox', label: '', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'assignedBucket', label: 'Assigned Bucket', alignRight: false },
  { id: 'actions', label: '', alignRight: false },
];

export const BUCKETS_TABLE_HEAD = [
  { id: 'checkbox', label: '', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'path', label: 'Path', alignRight: false },
  { id: 'size', label: 'Size', alignRight: false },
  { id: 'assignedUser', label: 'Assigned to', alignRight: false },
  { id: 'createdDate', label: 'Created at', alignRight: false },
  { id: 'actions', label: '', alignRight: false },
];

export const STORAGE_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  MAINTENANCE: 'Maintenance',
};

export const STORAGE_TYPES = {
  SHARED: 'Shared',
  PRIVATE: 'Private',
  TEMPORARY: 'Temporary',
};

export const DEFAULT_PAGE_SIZE = 5;
export const PAGE_SIZE_OPTIONS = [5, 10, 25];

export const STORAGE_UNITS = {
  BYTES: 'B',
  KILOBYTES: 'KB',
  MEGABYTES: 'MB',
  GIGABYTES: 'GB',
  TERABYTES: 'TB',
};

export const STORAGE_COLORS = {
  PRIMARY: '#0A9EF2',
  SUCCESS: '#4caf50',
  WARNING: '#ff9800',
  ERROR: '#f44336',
  INFO: '#2196f3',
};
